module.exports = __webpack_public_path__ + "static/media/twitter.b569e5e5.svg";